import styled, { css } from 'styled-components';

export const dialogTextMixin = css`
    color: ${({theme}) => theme.colors.textLight};
    font-size: 1.5rem;
    text-align: center;
`;

export const dialogHighlightedTextMixin = css`
    color: ${props => props.theme.colors.brandPrimary};
    font-size: 1.5rem;
    text-align: center;
`;

export const DialogTextBox = styled.div`
    margin-top: 2rem;
    ${dialogTextMixin}
`;

export const DialogHighlightedTextBox = styled.div`
    margin-top: 2rem;
    ${dialogHighlightedTextMixin}
`;

export const ListDialogTextBox = styled.div`
    color: ${({theme}) => theme.colors.textContrast};
    margin-top: 4rem;
    font-size: 1.5rem;
    text-align: left;
`;

export const DialogDimmedTextBox = styled.div` 
    margin-top: 2rem;
    font-size: 1.4rem;
    text-align: center;
    color: ${({theme}) => theme.colors.textMiddleDark};
    `;